import {ref, Ref} from 'vue';

export enum StatusType {
	DEFAULT = 'default',
	LOADING = 'loading',
	ALERT = 'alert',
}
export interface EditorStatusState {
	type: StatusType;
	message: string;
}

export class EditorStatusStoreControllerClass {
	// private _store!: Store<State>;
	private _type: Ref<StatusType> = ref(StatusType.DEFAULT);
	private _message: Ref<string> = ref('');
	private _autoClear: Ref<boolean> = ref(true);

	private static _instance: EditorStatusStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorStatusStoreControllerClass());
	}

	private constructor() {}

	type() {
		return this._type.value;
	}
	message(): string {
		return this._message.value;
	}
	autoClear() {
		return this._autoClear.value;
	}

	// methods
	hide() {
		this.setMessage('');
	}
	setMessage(message: string) {
		this._autoClear.value = true;
		this._message.value = message;
		this._type.value = StatusType.DEFAULT;
	}
	setLoading(message: string) {
		this._autoClear.value = false;
		this._message.value = message;
		this._type.value = StatusType.LOADING;
	}
	setError(message: string) {
		this._autoClear.value = false;
		this._message.value = message;
		this._type.value = StatusType.ALERT;
	}
}

export const EditorStatusStoreController = EditorStatusStoreControllerClass.instance();
